<template>
    <div v-loading="loading">
        <self-back :pageHeaderList="[{'name':'项目列表','path': '/projectList'},{'name':'文档管理'}]"></self-back>
        <div class="tabs_box clear">
            <div class="tab_item" :class="tab == item.id ? 'active' : ''" @click="tab = item.id; getFileList(1)" v-for="(item,index) in fileTabs" :key="index">{{item.name}}</div>
        </div>
        <div class="fileCantiner">
            <div class="topOperation clear">
                <div class="left">
                    <button @click="uploadButtonClick">上传</button>
                    <button @click="downLoadFiles">下载</button>
                    <button @click="deteleFiles">删除</button>
                    <button @click="moveFiles">移动</button>
                </div>
                <div class="right">
                    <el-input placeholder="请输入文件名称" v-model.trim="keyword" clearable  @keydown.enter.native="keyword?getFileList(1):''" @clear="getFileList(1)" size="mini" style="width:200px">
                        <el-button slot="append" icon="el-icon-search" @click="keyword?getFileList(1):''" style="padding:0 10px"></el-button>
                    </el-input>
                </div>
            </div>
            <div class="listBox">
                <el-table
                    height="calc(100vh - 287px)"
                    ref="multipleTable"
                    :data="tableData"
                    tooltip-effect="dark"
                    style="width: 100%"
                    @selection-change="handleSelectionChange">
                    <el-table-column type="selection" width="55"></el-table-column>
                    <el-table-column label="文件名" show-overflow-tooltip>
                        <template slot-scope="scope">{{ scope.row.doc_name }}</template>
                    </el-table-column>
                    <el-table-column align="center" label="文件类型" >
                        <template slot-scope="scope">
                            {{scope.row.file_type == 1 ? '视频' : scope.row.file_type == 2 ? '文档' : scope.row.file_type == 3 ? '图片' : '其他'}}
                        </template>
                    </el-table-column>
                    <el-table-column align="center" label="文档类型" >
                        <template slot-scope="scope">
                            {{scope.row.doc_type == 1 ? '快接单开户' : scope.row.doc_type == 2 ? '达人推荐' : scope.row.doc_type == 3 ? '确认达人' : scope.row.doc_type == 4 ? '确认脚本' : scope.row.doc_type == 5 ? '达人拍摄' : scope.row.doc_type == 6 ? '视频确认' : scope.row.doc_type == 7 ? '发布视频' : scope.row.doc_type == 8 ? '投放数据' : '其他'}}
                        </template>
                    </el-table-column>
                    <el-table-column prop="file_size" label="大小" align="center" ></el-table-column>
                    <el-table-column prop="updated_at" label="更新时间" sortable align="center" show-overflow-tooltip ></el-table-column>
                    <el-table-column label="创建者" align="center" >
                        <template slot-scope="scope">{{ scope.row.operator_role }}({{ scope.row.operator_name }})</template>
                    </el-table-column>
                    <el-table-column label="操作" align="center">
                        <template slot-scope="scope">
                            <div class="projectItemOperation" @click="lookFile(scope.row)">查看</div>
                        </template>
                    </el-table-column>
                </el-table>
                <div class="paginationBox">
                    <el-pagination
                       small
                        background
                        :current-page="page"
                        :page-size="page_size"
                        @current-change="handleCurrentChange"
                        layout="total, prev, pager, next"
                        :total="total">
                    </el-pagination>
                </div>
            </div>
        </div>
        <!-- 上传 -->
        <el-dialog title="上传文件" :visible.sync="uploadFlag" width="400px" top="10vh" :close-on-click-modal='false'>
            <el-upload
                ref="upload"
                :action="URL.BASEURL + URL.documentAdd"
                :on-change="fileBefore"
                :on-success="uploadSuccess"
                :on-error="uploadError"
                :data="uploadFileData"
                :show-file-list='true'
                :auto-upload="false"
                :file-list="uoloadList"
                :limit='1'
                :on-exceed='fileExceed'
                >
                <button class="uploadFileButton">选取文件</button>
                <div slot="tip" class="el-upload__tip" style="display:inline-block;margin-left:10px;">注：上传单个文件，大小限制在10M以内</div>
            </el-upload>
            
            <!-- <div style="margin-top:20px" v-if="uploadFileData.file_name">
                <label>文件名称：</label>
                <el-input
                    style="width:230px"
                    placeholder="请输入文件名称"
                    v-model="file_self_name"
                    size="mini"
                    clearable>
                </el-input>
                <span>.{{file_suffix}}</span>
            </div> -->
            <div style="margin-top:20px">
                <label>选择上传类型：</label>
                <el-select style="width:160px" v-model="uploadFileData.doc_type" size='mini' filterable placeholder="请选择">
                    <el-option
                    v-for="(item,index) in uploadFileTabs"
                    :key="index"
                    :label="item.name"
                    :value="item.id">
                    </el-option>
                </el-select>
            </div>
            <el-button size="small" type="primary" @click="submitUpload" style="display:block;margin:30px auto 0;">上传文件</el-button>
        </el-dialog>
        <!-- 查看文件  -->
        <el-dialog :title="lookData.doc_name" :visible.sync="lookFlag" width="70%" top="10vh">
            <video :src="lookData.download_url" v-if="lookData.file_type == 1" style="margin: auto;display: block;max-width: 90%;" preload="meta" autoplay controls="controls">您的浏览器不支持 video 标签。</video>
            <!-- 图片预览 -->
            <img :src="lookData.download_url" v-if="lookData.file_type == 3" style="width:80%;margin:auto;"/>

            <!-- pdf预览 -->
            <iframe :src="lookData.download_url" width="100%" height='100%' v-if="lookData.file_type == 2&&fileType==1" style="height:800px;"></iframe>
            <!-- docx/xlsx/xls -->
            <iframe v-if="lookData.file_type == 2&&fileType==2" :src="`https://view.officeapps.live.com/op/view.aspx?src=${lookData.download_url}`" width='100%' height='100%' frameborder='1' style="height:800px;"></iframe>
            <!-- .csv  -->
            <el-table
                height="70vh"
                v-if="lookData.file_type == 2&&fileType==3"
                ref="multipleTable"
                :data="csvData"
                border
                style="width: 100%">
                <el-table-column v-for="(item,index) in csvTh" :key="index" align="center" :label="item" width="180px" show-overflow-tooltip>
                    <template  slot-scope="scope">
                        {{(scope.row)[index]}}
                    </template>
                </el-table-column>
            </el-table>
        </el-dialog>
        <!-- 文件移动到 -->
        <el-dialog title="移动文件" :visible.sync="moveFlag" width="400px" top="10vh" :close-on-click-modal='false'>
            <el-radio-group v-model="moveId">
                <el-radio :label="item.id" style="width:33%;margin:8px auto;" v-for="(item,index) in uploadFileTabs" :key="index">{{item.name}}</el-radio>
            </el-radio-group>
            <div slot="footer" style="text-align: center;">
                <el-button size='small' @click="moveFlag=false">取 消</el-button>
                <el-button type="primary" @click="moveFilesYes" size='small'>确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
export default {
    data(){
        return{
            uploadFlag:false,
            page:1,
            page_size:20,
            total:0,
            loading:false,
            fileTabs:[
                {id:0,name:'全部'},
                {id:1,name:'快接单开户'},
                {id:2,name:'达人推荐'},
                {id:3,name:'确认达人'},
                {id:4,name:'确认脚本'},
                {id:5,name:'达人拍摄'},
                {id:6,name:'视频确认'},
                {id:7,name:'发布视频'},
                {id:8,name:'投放数据'},
            ],
            tab:0,
            keyword:'',
            multipleSelection:[],
            tableData:[],
            project_id:'',
            uploadFileData:{
                project_id:'',
                doc_type:'',
                file_name:'',
                admin_id: JSON.parse(this.$cookie.getCookie('userInfo')).admin_id,
                ttl: JSON.parse(this.$cookie.getCookie('userInfo')).ttl,
                sign: JSON.parse(this.$cookie.getCookie('userInfo')).sign
            },
            uploadFileTabs:[
                {id:1,name:'快接单开户'},
                {id:2,name:'达人推荐'},
                {id:3,name:'确认达人'},
                {id:4,name:'确认脚本'},
                {id:5,name:'达人拍摄'},
                {id:6,name:'视频确认'},
                {id:7,name:'发布视频'},
                {id:8,name:'投放数据'},
            ],
            uoloadList:[],
            lookFlag:false,
            lookData:{},
            fileType:'',
            csvTh:[],
            csvData:[],
            moveFlag:false,
            moveId:''
            // file_self_name:'',
            // file_suffix:''
        }
    },
    created(){
        this.project_id = this.$route.params.project_id;
        this.uploadFileData.project_id = this.project_id;
        this.getFileList(1)
    },
    methods:{
        uploadButtonClick(){
            this.uploadFileData.doc_type = '';
            this.uploadFileData.file_name = '';
            // this.file_self_name = '';
            // this.file_suffix = '';
            if(this.tab!=0){
                this.uploadFileData.doc_type = this.tab
            }
            this.uploadFlag=true
        },
        lookFile(data){//查看文件
            var _this = this;
            this.lookData = data;
            this.fileType = '';
            this.csvTh = [];
            this.csvData = [];
            if(this.lookData.file_type == 2){//文档类型
                var url = this.lookData.download_url;
                url.indexOf('.txt') != -1 || url.indexOf('.pdf') != -1 || url.indexOf('.html') != -1 ? this.fileType=1 :'';//txt pdf html
                url.indexOf('.doc') != -1 || url.indexOf('.xls') != -1 ? this.fileType=2 :'';//docx/xlsx/xls/doc
                url.indexOf('.csv') != -1 ? this.fileType=3 :'';//csv
            }
            if(this.fileType==3){
                Papa.parse(url, {
                    download: true,
                    complete: function(results) {
                        var data = results.data;
                        _this.csvTh = data[0]
                        _this.csvData = data.slice(1);
                    }
                });
            }
            this.lookFlag = true
        },
        submitUpload() {//上传
            if(this.uploadFileData.file_name==''){
                this.$message({
                    message: '请选择文件',
                    type: 'warning'
                })
                return
            }
            // if(this.file_self_name == ''){
            //     this.$message({
            //         message: '请输入文件名',
            //         type: 'warning'
            //     })
            //     return
            // }
            if(!this.uploadFileData.doc_type || this.uploadFileData.doc_type == ''){
                this.$message({
                    message: '请选择文件上传类型',
                    type: 'warning'
                })
                return;
            }
            this.$refs.upload.submit();
        },
        fileBefore(file,fileList) {
            if(!file.response){
                this.uploadFileData.file_name = file.name;
            }
            // this.file_self_name = this.extname(file.name).name;
            // this.file_suffix = this.extname(file.name).suffix;
        },
        // extname(filename){
        //     if(!filename||typeof filename!='string'){
        //         return false
        //     };
        //     let a = filename.split('').reverse().join('');
        //     let b = a.substring(0,a.search(/\./)).split('').reverse().join('');
        //     let c = (a.substring((a.search(/\./)+1))).split('').reverse().join('');
        //     return {name:c,suffix:b}
        // },
        fileExceed(file){
            this.$message({
                message: '超出限制，一次仅允许上传一个文件！',
                type: 'warning'
            })
        },
        uploadSuccess(res, file, fileList){
            if(res.errno == 0){
                this.uoloadList = [];
                this.uploadFileData.doc_type = '';
                this.uploadFileData.file_name = '';
                // this.file_self_name = '';
                // this.file_suffix = '';
                this.getFileList(this.page)
                this.$message({
                    message: '上传成功',
                    type: 'success'
                })
            }else {
                this.$message({
                    message: res.err,
                    type: 'warning'
                })
            }
            
        },
        uploadError(err, file, fileList){
            this.$message({
                message: '上传失败',
                type: 'fail'
            })
        },
        getFileList(page){
            this.page = page;
            this.loading = true;
            this.$axios.get(this.URL.BASEURL + this.URL.documentList,{
                params:{
                    page:this.page,
                    page_size: this.page_size,
                    doc_type:this.tab,
                    project_id: this.project_id,
                    keyword:this.keyword
                }
            }).then((res) => {
                var res=res.data;
                this.loading = false;
                if(res&& res.errno == 0){
                    this.tableData = res.rst.data;
                    this.total = res.rst.pageInfo.total;
                }else {
                    this.$message({
                        message: res.err,
                        type: 'warning'
                    })
                }
            }).catch(()=>{
                this.loading = false
            })
        },
        handleCurrentChange(val){
            this.getFileList(val)
        },
        handleSelectionChange(val) {
            this.multipleSelection = val;
        },
        moveFiles(){//移动
            if(!this.multipleSelection||this.multipleSelection.length==0){
                this.$message({
                    message: '请选择您要移动的文件',
                    type: 'warning'
                })
                return
            }
            this.moveId = '';
            this.moveFlag = true;
        },
        moveFilesYes(){//移动确认
            if(!this.moveId || this.moveId==''){
                this.$message({
                    message: '请选择您要移动到的文档类型',
                    type: 'warning'
                })
                return
            }
            var ids = [];
            this.multipleSelection.forEach((item)=>{
                ids.push(item.id)
            })
            this.loading = true;
            this.$axios.post(this.URL.BASEURL + this.URL.documentMove,{
                ids: ids,
                type: this.moveId
            }).then((res) => {
                var res=res.data;
                if(res&& res.errno == 0){
                    this.getFileList(1)
                    this.moveFlag = false;
                    this.$message({
                        message: '移动成功',
                        type: 'success'
                    })
                }else {
                    this.loading = false;
                    this.$message({
                        message: res.err,
                        type: 'warning'
                    })
                }
            }).catch(()=>{
                this.loading = false
            })
        },
        deteleFiles(){//删除
            if(!this.multipleSelection||this.multipleSelection.length==0){
                this.$message({
                    message: '请选择您要删除的文件',
                    type: 'warning'
                })
                return
            }
            this.$confirm('确定要删除所选中文件吗?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                var ids = [];
                this.multipleSelection.forEach((item)=>{
                    ids.push(item.id)
                })
                this.loading = true;
                this.$axios.post(this.URL.BASEURL + this.URL.documentDel,{
                    ids: ids,
                }).then((res) => {
                    var res=res.data;
                    if(res&& res.errno == 0){
                        this.getFileList(1)
                        this.$message({
                            message: '删除成功',
                            type: 'success'
                        })
                    }else {
                        this.loading = false;
                        this.$message({
                            message: res.err,
                            type: 'warning'
                        })
                    }
                }).catch(()=>{
                    this.loading = false
                })
            }).catch(() => {     
            });
        },
        downLoadFiles(){//下载
            if(!this.multipleSelection||this.multipleSelection.length==0){
                this.$message({
                    message: '请选择您要下载的文件',
                    type: 'warning'
                })
                return
            }
            this.multipleSelection.forEach((item)=>{
                var url = item.download_url;
                var doc_name = item.doc_name
                this.ajax(url, (xhr) => {
                    var filename = doc_name
                    this.downloadFile(xhr.response, filename)
                }, {
                    responseType: 'blob'
                })
            })
        },
        downloadFile(content, filename) {
            var a = document.createElement('a')
            var blob = new Blob([content])
            var url = window.URL.createObjectURL(blob)
            a.href = url
            a.download = filename
            a.click()
            window.URL.revokeObjectURL(url)
        },
        ajax(url, callback, options) {
            window.URL = window.URL || window.webkitURL
            var xhr = new XMLHttpRequest()
            xhr.open('get', url, true)
            if (options.responseType) {
                xhr.responseType = options.responseType
            }
            xhr.onreadystatechange = function() {
                if (xhr.readyState === 4 && xhr.status === 200) {
                    callback(xhr)
                }
            }
            xhr.send()
        }
    },
    watch:{
        // file_self_name(){
        //     if(this.file_self_name!=''){
        //         this.uploadFileData.file_name = this.file_self_name + '.' + this.file_suffix;
        //     }
        // }
    }
}
</script>
<style lang="scss" scoped>
.fileCantiner{
    width: 100%;
    background: #FFFFFF;
    box-shadow: 0px -1px 6px 0px rgba(32, 38, 82, 0.1);
    position: relative;
    .topOperation{
        padding: 16px;
        .left{
            float: left;
            button{
                width: 50px;
                height: 22px;
                border-radius: 2px;
                border: 1px solid #5B7BFE;
                background: transparent;
                color: #5B7BFE;
                font-size: 12px;
                margin-right: 14px;
                margin-top: 3px;
            }
        }
        .right{
            float: right;
        }
    }
    .listBox{
        border-top: 1px solid #E6E6EF;
        .projectItemOperation{
            width: 85px;
            height: 28px;
            border-radius: 2px;
            border: 1px solid #5B7BFE;
            text-align: center;
            position: relative;
            display: inline-block;
            color: #5B7BFE;
            font-size: 13px;
            line-height: 28px;
            transform: scale(0.86);
            cursor: pointer;
            .selectProject{
                width: 100%;
                height: 100%;
                position: absolute;
                top: 0;
                left: 0;
                opacity: 0;
            }
        }
    }
}
.tabs_box{
    .tab_item{
        background: #FFFFFF;
        display: inline-block;
        line-height: 50px;
        padding: 0 25px;
        color: #767A9A;
        font-size: 15px;
        font-weight: 500;
        cursor: pointer;
        &.active{
            background: #5B7BFE;
            color: #FFFFFF;
        }
    }
}
.uploadFileButton{
    background: transparent;
    border: none;
    color: #5c7bfe;
    font-size: 12px;
    padding: 3px 6px;
    border-radius: 3px;
    border: 1px solid #5c7bfe;
}
#table{
    th{
        width: 100px;
    }
}
</style>


// WEBPACK FOOTER //
// src/components/file/placeFile.vue